module.exports = __webpack_public_path__ + "static/img/RedBubble@3x.ae215f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/places/RedBubble@3x.png
// module id = JUb6
// module chunks = 0